// eslint-disable-next-line jira/restricted/react-component-props
import React, { type ComponentType, type ComponentProps } from 'react';
import { lazy } from 'react-loosely-lazy';
import { PerformanceMark } from '@atlassian/jira-common-performance';
import Placeholder from '@atlassian/jira-placeholder';
import type { InjectedProps } from '@atlassian/jira-portfolio-3-portfolio/src/common/view/experience-tracking';
import type View from './view';

const METRIC_KEY = 'LOAD_START_ADVANCED_ROADMAPS_DEPENDENCIES_PAGE';

// We can't just use `Props` here because that includes `intl` which is injected in view.js
type ViewOuterProps = JSX.LibraryManagedAttributes<typeof View, ComponentProps<typeof View>>;

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const Page = lazy<ComponentType<Flow.Diff<ViewOuterProps, InjectedProps>>>(
	() => import(/* webpackChunkName: "async-advanced-roadmaps-dependencies-page" */ './index'),
	{ ssr: false },
);

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (props: Flow.Diff<ViewOuterProps, InjectedProps>) => (
	<Placeholder
		name="advanced-roadmaps-dependencies-page"
		fallback={<PerformanceMark metricKey={METRIC_KEY} />}
	>
		<Page {...props} />
	</Placeholder>
);

export const preload = Page.preload;
